import { render } from "./Sales_Agents.vue?vue&type=template&id=0bdec658&scoped=true"
import script from "./Sales_Agents.vue?vue&type=script&lang=js"
export * from "./Sales_Agents.vue?vue&type=script&lang=js"

import "./Sales_Agents.vue?vue&type=style&index=0&id=0bdec658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdec658"]])

export default __exports__